import { AttachmentViewState } from 'owa-attachment-select-actions';
import { AttachmentModel } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import * as React from 'react';
import { AttachmentIconView, AttachmentDocInfoView } from 'owa-attachment-view';
import { IconSize } from 'owa-attachment-common-view';
import TypeOfAttachment from 'owa-attachment-model-store/lib/store/schema/TypeOfAttachment';
import { highlightTermsInHtmlElement } from 'owa-mail-highlight-terms';

const styles = require('./AttachmentCompactView.scss');

export interface AttachmentDocCompactProps {
    attachmentViewState: AttachmentViewState;
    attachment?: AttachmentModel;
    isShortDocView: boolean;
}

export default function AttachmentDocView(props: AttachmentDocCompactProps) {
    props = {
        attachment: getAttachment(props.attachmentViewState.attachmentId),
        ...props,
    };
    const isDocLink = props.attachment.type === TypeOfAttachment.Link;
    return (
        <div
            className={
                props.isShortDocView ? styles.shortAttachmentDocView : styles.attachmentDocView
            }>
            <AttachmentIconView
                attachmentId={props.attachmentViewState.attachmentId}
                className={styles.iconCompactMode}
                iconSize={IconSize.extraSmall}
            />

            <AttachmentDocInfoView
                attachmentViewState={props.attachmentViewState}
                attachment={props.attachment}
                firstLineStyle={
                    isDocLink
                        ? styles.infoCompactModeFirstLineLink
                        : styles.infoCompactModeFirstLine
                }
                secondLineStyle={styles.infoCompactModeSecondLine}
                isShortDocView={props.isShortDocView}
                highlightAttachmentName={highlightAttachmentName}
            />
        </div>
    );
}

function highlightAttachmentName(ref: HTMLDivElement) {
    highlightTermsInHtmlElement(ref);
}
